const p40elite = () => {
   return (
      <p>
         P40 ELITE предлагает баланс между совершенными клиническими результатами и максимальной эффективностью, превосходящей ваши ожидания. Соответствуя уровню премиум-класса, P40 ELITE предоставляет пользователю полную диагностическую информацию, расширенную функциональность и эргономичную систему, отвечающую большому числу пациентов и постоянно растущим требованиям к ультразвуковым исследованиям во всех сферах.<br /><br />
         <strong>Технические характеристики</strong><br />
         •	21,5-дюймовый монитор и 13,3-дюймовый сенсорный HD-экран позволяют снизить усталость и обеспечить плавную работу. Тонкая и прочная конструкция с ручкой сзади обеспечивает улучшенную мобильность и простоту размещения даже в ограниченных пространствах.<br />
         •	Аккумулятор большой емкости поддерживает непрерывную работу до 2 часов на случай отключения электроэнергии.<br />
         •	Простая в использовании компрессионная эластография доступна на линейном, конвексном и внутриполостном датчиках для измерения плотности тканей во всех областях применения.<br />
         •	Полный набор датчиков и инструментов повышает уверенность врачей в постановленном диагнозе и качестве обслуживания.<br />
      
      </p>
   );
}

export default p40elite;
